// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-icon {
  /* width: 300px; Fixed width */
 /*  height: 400px; /* Fixed height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 19px;
  background-color: #005293;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  box-sizing: border-box; /* Ensures padding is included in dimensions */
  text-align: center;
  color: white;
  /* Optional: Ensure consistent aspect ratio */
  width: 100%; /* Make the card width responsive */
}
.logo {
  width: 100px; /* Consistent logo width */
  border-radius: 20px; /* Keeps your rounded corners for logos */
  margin-bottom: 10px;
}
  
h3 {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
  min-height: 40px; /* Ensures consistent height for titles */
}

p {
  font-size: 14px;
  text-align: center;
  margin: 0;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Limits to 3 lines */
  -webkit-box-orient: vertical;
}

@media screen and (max-width: 768px) {
  .app-icon {
    margin-bottom: 20px;
  }
}

.image-container img {
  display: block;
  width: 100%; /* Ensures the image scales with its container */
  object-fit: contain; /* Maintains aspect ratio without distortion */
}

.image-container {
  width: 100%; /* Matches the container's width */
  overflow: hidden; /* Ensures no overflow from large images */
  
}



  
  .image-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    font-weight: bold;
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 10px;
    border-radius: 5px;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/AppIcon.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;CAC/B,oCAAoC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,sBAAsB,EAAE,8CAA8C;EACtE,kBAAkB;EAClB,YAAY;EACZ,6CAA6C;EAC7C,WAAW,EAAE,mCAAmC;AAClD;AACA;EACE,YAAY,EAAE,0BAA0B;EACxC,mBAAmB,EAAE,yCAAyC;EAC9D,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB,EAAE,sBAAsB;EAC7C,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,gDAAgD;EAC7D,mBAAmB,EAAE,8CAA8C;AACrE;;AAEA;EACE,WAAW,EAAE,kCAAkC;EAC/C,gBAAgB,EAAE,0CAA0C;;AAE9D;;;;;EAKE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB","sourcesContent":[".app-icon {\n  /* width: 300px; Fixed width */\n /*  height: 400px; /* Fixed height */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border-radius: 19px;\n  background-color: #005293;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box; /* Ensures padding is included in dimensions */\n  text-align: center;\n  color: white;\n  /* Optional: Ensure consistent aspect ratio */\n  width: 100%; /* Make the card width responsive */\n}\n.logo {\n  width: 100px; /* Consistent logo width */\n  border-radius: 20px; /* Keeps your rounded corners for logos */\n  margin-bottom: 10px;\n}\n  \nh3 {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px 0;\n  min-height: 40px; /* Ensures consistent height for titles */\n}\n\np {\n  font-size: 14px;\n  text-align: center;\n  margin: 0;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Limits to 3 lines */\n  -webkit-box-orient: vertical;\n}\n\n@media screen and (max-width: 768px) {\n  .app-icon {\n    margin-bottom: 20px;\n  }\n}\n\n.image-container img {\n  display: block;\n  width: 100%; /* Ensures the image scales with its container */\n  object-fit: contain; /* Maintains aspect ratio without distortion */\n}\n\n.image-container {\n  width: 100%; /* Matches the container's width */\n  overflow: hidden; /* Ensures no overflow from large images */\n  \n}\n\n\n\n  \n  .image-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 24px;\n    font-weight: bold;\n    color: white;\n    background-color: rgba(0, 0, 0, 0.7);\n    padding: 10px;\n    border-radius: 5px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
